import { create } from 'zustand'
import { devtools } from 'zustand/middleware'

export type BreadcrumbItem = {
  label: string
  href: string
  active?: boolean
}

type BreadcrumbState = {
  items: BreadcrumbItem[]
}

type BreadcrumbStore = {
  state: BreadcrumbState
  setItems: (items: BreadcrumbItem[]) => void
  addItem: (item: BreadcrumbItem) => void
  removeBreadcrumbItem: (item: BreadcrumbItem) => void
  reset: () => void
}

const initialState: BreadcrumbState = {
  items: []
}

const useBreadcrumbStore = create<BreadcrumbStore>()(
  devtools(set => ({
    state: initialState,
    setItems: (items: BreadcrumbItem[]) => {
      set(() => ({
        state: {
          items
        }
      }))
    },
    addItem: (item: BreadcrumbItem) => {
      set(state => ({
        state: {
          items: [...state.state.items, item]
        }
      }))
    },
    removeBreadcrumbItem: (item: BreadcrumbItem) => {
      set(state => ({
        state: {
          items: state.state.items.filter(i => i.label !== item.label && i.href !== item.href)
        }
      }))
    },
    reset: () => {
      set(() => ({
        state: initialState
      }))
    }
  }))
)

export default useBreadcrumbStore
